// app/features/ai-workflows/services_and_hooks/deriveValidPage.ts

export function deriveValidPage(
  requestedPage: number,
  totalRecords: number | undefined,
  pageSize: number,
): number {
  const page = requestedPage < 1 ? 1 : requestedPage;
  if (typeof totalRecords !== "number" || totalRecords <= 0 || pageSize <= 0) {
    return page;
  }

  const totalPages = Math.ceil(totalRecords / pageSize);
  if (totalPages > 0 && page > totalPages) {
    return 1;
  }

  return page;
}
